<template>
<div class="page_tixian">
	 <!-- 付款 -->
    <!-- <div class="tixian">
        <div class="balance">
            <div class="balance_t">
                <span class="tag_cash">¥</span>
                <van-field v-model="price" type="number" placeholder="请输入付款金额" class="cash_field" />
            </div>
        </div>
    </div>
    <van-button block :loading="submitLoading" class="big_btn" @click="tijiao">立即支付</van-button> -->
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
			submitLoading: false,
			price: null
        };
    },
    components: {
        PageSearch
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '支付'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token

                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token

        }
    },
    methods: {
		tijiao(){
			var that = this
			if(!that.price){
				that.$toast('请输入金额')
				return
			}else{
				that.submitLoading = true
			}
			var params = {
				token: that.token,
				fee: that.price
			}
			that.$api.common.pay(params).then(res=>{
				if(res.code == 200){
					var config = res.result.config
					that.wxPay(config)
				}else{
					that.$toast(res.message)
					that.submitLoading = false
				}
			})
		},
        // 微信支付
        wxPay(config) {
			var that = this
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: config.appId, // 必填，公众号的唯一标识
                timestamp: config.timeStamp, // 必填，生成签名的时间戳
                nonceStr: config.nonceStr, // 必填，生成签名的随机串
                signature: config.paySign, // 必填，签名，见附录1
                jsApiList: ["chooseWXPay"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            // 配置失败返回
            wx.error(function (res) {
                console.log('error')
                console.log(res)
				that.$toast("微信支付配置失败！");
				that.submitLoading = false
            });
            wx.ready(function () {
                // 调起微信支付
                wx.chooseWXPay({
                    timestamp: config.timeStamp,
                    nonceStr: config.nonceStr,
                    package: config.package,
                    signType: config.signType,
                    paySign: config.paySign, // 支付签名
                    success: function (res) {
						that.submitLoading = false
						that.$toast("支付成功");
                    },
                    error: function (res) {
						that.submitLoading = false
						that.$toast("支付失败");
                    },
                    cancel: function (res) {
						that.submitLoading = false
						that.$toast("您取消了支付,请重新提交");
                    }
                });
            });
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
